<custom-dropdown-list-container [ngStyle]="{'width': width}" [(isDropdownOpen)]="isDropdownOpen">
    <div class="custom-dropdown-select" dropdown-toggle>
        <div>
            {{getItemLabel(selectedItem)}}
        </div>
    <div class="custom-arrow-wrapper">
        <i class="custom-arrow" [class.down]="!isDropdownOpen" [class.up]="isDropdownOpen"></i>
    </div></div>
    <div [ngClass]="'custom-dropdown-items custom-dropdown-' + backgroundTone" dropdown-list>
        <div class="custom-dropdown-item" *ngFor="let item of items" (click)="selectItem(item)">
            <div>{{getItemLabel(item)}}</div>
        </div>
    </div>
</custom-dropdown-list-container>